import { InvoicesList } from '@/components/Billing/InvoicesList';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

// Cette page utilise maintenant le nouveau système de facturation à l'usage
// Elle affiche simplement la liste des factures mensuelles

// Supprimé - Remplacé par InvoicesList

// Main Invoices Page
export const InvoicesPage = () => {
  const { t } = useTranslation();
  const [, setSelectedInvoiceUuid] = useState<string | null>(null);

  const handleViewInvoiceDetails = (invoiceUuid: string) => {
    setSelectedInvoiceUuid(invoiceUuid);
  };

  return (
    <div className="space-y-6 sm:space-y-8">
      {/* Header */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        <div className="bg-primary-100 flex h-10 w-10 items-center justify-center rounded-2xl sm:h-12 sm:w-12">
          <FileText className="text-primary-600 h-5 w-5 sm:h-6 sm:w-6" />
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="text-2xl font-bold text-neutral-900 sm:text-3xl">
            {t('billing.invoices.title', 'Historique des factures')}
          </h1>
          <p className="text-base text-neutral-600 sm:text-lg">
            {t(
              'billing.invoices.subtitle',
              'Consultez vos factures mensuelles'
            )}
          </p>
        </div>
      </div>

      {/* Invoices List */}
      <InvoicesList onViewDetails={handleViewInvoiceDetails} />
    </div>
  );
};
